'use client';

import * as DS from '@aurorasolar/ds';
import Image from 'next/image';

export type ImageNode = { altText: string; sourceUrl: string };

export type Props = { img?: ImageNode; subheader: string; title?: string | null };

const { xl } = DS.BorealisTheme.screens;

export const PostHero = ({ title, img, subheader }: Props) => {
  const imageSrc = img?.sourceUrl ? new URL(img.sourceUrl).pathname : '';

  return (
    <DS.Flex bg="uiBgAlternate">
      <DS.Flex gap={0} maxW={xl} mx="auto">
        {img ? (
          <DS.Box overflow="hidden" pt={8} px={{ _: 4, md: 8 }} w="100%">
            <Image
              alt={img.altText}
              height={0}
              priority
              sizes={`(max-width: ${xl}px) 100vw, ${xl}px`}
              src={imageSrc}
              style={{ height: 'auto', maxHeight: '600px', objectFit: 'cover', width: '100%' }}
              width={0}
            />
          </DS.Box>
        ) : null}
        <DS.Flex flexDirection="column" gap={2} px={{ _: 4, md: 8 }} py={{ _: 4, md: 8 }}>
          {title ? (
            <DS.Text as="h1" fontWeight="300" text="d3">
              {title}
            </DS.Text>
          ) : null}
          <DS.Text text="body20">{subheader}</DS.Text>
        </DS.Flex>
      </DS.Flex>
    </DS.Flex>
  );
};

export const PostHeroSkeleton = () => (
  <DS.Flex bg="uiBgAlternate" mb={10}>
    <DS.Flex maxW={xl} mx="auto">
      <DS.Box pt={8} px={{ _: 4, md: 8 }}>
        <DS.SkeletonLoader h={500} mb={0} w="100%" />
      </DS.Box>

      <DS.Flex flexDirection="column" gap={2} px={{ _: 4, md: 8 }} py={8}>
        <DS.SkeletonLoader h={138} mb={0} w="100%" />
      </DS.Flex>
    </DS.Flex>
  </DS.Flex>
);
